module.exports = __webpack_public_path__ + "img/es-rdf.0aa049e8.svg";